<template>
  <div class="reply">
    <img class="face" :src="`./images/imavatars/${avatar}.png`" :alt="avatar"/>
    <div class="content">
      <div class="name">{{name}}</div>
      <div class="text" v-html="text"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PostReply',
  props: ['avatar', 'name', 'text']
}
</script>

<style lang="scss" scoped>
.reply {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin: 12px 18px 12px 26px;
  padding: 14px 18px;
  background: rgba(0, 0, 0, .26);
  border-radius: 12px;
  .face {
    flex: none;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    border: 2px solid var(--line-dim);
    background: var(--surface);
    box-sizing: border-box;
    object-fit: cover;
    user-select: none;
  }
  .content {
    flex: 1;
    min-width: 0;
    white-space: pre-line;
    word-break: break-word;
    .name {
      margin-bottom: 2px;
      font-size: .95em;
      color: var(--dim);
      line-height: 1.1;
    }
    .text {
      font-size: 1.1em;
      line-height: 1.35;
    }
  }
}
</style>
